if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
        /**
         * Target date for the countdown
         * 
         * @type {number}
         */
        targetDate;

        /**
         * Countdown elements
         * 
         * @type {Object}
         */
        countdownElements;

        constructor() {
            super();

            // Initialize countdownElements directly
            this.countdownElements = {
                // 十位数和个位数放一起的类名或id名
                days: this.querySelector('.times_day'),
                hours: this.querySelector('.times_hour'),
                minutes: this.querySelector('.times_minute'),
                seconds: this.querySelector('.times_second'),

                // 十位数和个位数分开的类名或id名
                days_1: this.querySelector('.times_day1'),
                days_2: this.querySelector('.times_day2'),
                hours_1: this.querySelector('.times_hour1'),
                hours_2: this.querySelector('.times_hour2'),
                minutes_1: this.querySelector('.times_minute1'),
                minutes_2: this.querySelector('.times_minute2'),
                seconds_1: this.querySelector('.times_second1'),
                seconds_2: this.querySelector('.times_second2'),
            };

            // Initialize targetDate from data-date attribute
            this.targetDate = new Date(this.getAttribute("data-date")).getTime();
            this.updateCountdown();

            // Update every second
            setInterval(() => this.updateCountdown(), 1000);
        }

        updateCountdown() {
            const now = new Date().getTime();
            const timeRemaining = this.targetDate - now;

            if (timeRemaining <= 0) {
                // Countdown is over
                this.resetCountdown();
            } else {
                // Calculate remaining days, hours, minutes, and seconds
                const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                // Update countdown elements
                this.updateElement(this.countdownElements.days, days < 10 ? '0' + days : days);
                this.updateElement(this.countdownElements.hours, hours < 10 ? '0' + hours : hours);
                this.updateElement(this.countdownElements.minutes, minutes < 10 ? '0' + minutes : minutes);
                this.updateElement(this.countdownElements.seconds, seconds < 10 ? '0' + seconds : seconds);

                this.updateElement(this.countdownElements.days_1, days < 10 ? days : (days / 10) | 0);
                this.updateElement(this.countdownElements.days_2, days < 10 ? '0' : days % 10);

                this.updateElement(this.countdownElements.hours_1, hours < 10 ? hours : (hours / 10) | 0);
                this.updateElement(this.countdownElements.hours_2, hours < 10 ? '0' : hours % 10);

                this.updateElement(this.countdownElements.minutes_1, minutes < 10 ? minutes : (minutes / 10) | 0);
                this.updateElement(this.countdownElements.minutes_2, minutes < 10 ? '0' : minutes % 10);

                this.updateElement(this.countdownElements.seconds_1, seconds < 10 ? seconds : (seconds / 10) | 0);
                this.updateElement(this.countdownElements.seconds_2, seconds < 10 ? '0' : seconds % 10);
            }
        }

        updateElement(element, value) {
            if (element) {
                element.textContent = value;
            }
        }

        resetCountdown() {
            // Countdown is over
            this.style.display = "none";
            document.body.classList.add("time-out");
        }
    }

    // Use custom element tag name without a dot
    customElements.define('countdown-timer', CountdownTimer);
}